export default status => {
    return {
        'PENDING': 'Pending approval',
        'PROCESSED': 'Processed',
        'REJECTED': 'Rejected',
        'REVERTED': 'Reverted',
        'ERROR': 'Error'
    }[status];
};
